module.exports = __webpack_public_path__ + "img/chart6.fc9a6179.png";